import { convertToRem, convertToRelativeRem } from '@appkit4/angular-components/utils';
import * as i0 from '@angular/core';
import { Injectable, Directive, NgModule } from '@angular/core';
import { BehaviorSubject, Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

let slideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
    }
    else {
        return slideUp(target, duration);
    }
};
let slideUp = (target, duration = 500) => {
    // target.style.transitionProperty = 'height, margin, padding';
    // target.style.transitionDuration = duration + 'ms';
    target.style.transition = `height ${duration}ms, margin ${duration}ms, padding ${duration}ms`;
    target.style.boxSizing = 'border-box';
    target.style.display = 'block';
    target.style.height = convertToRem(target.offsetHeight);
    // target.offsetHeight;
    target.style.overflow = 'hidden';
    let reduceHeightTimer = setTimeout(() => {
        target.style.height = 0;
        clearTimeout(reduceHeightTimer);
    }, 0);
    // target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    let timer = window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        // target.style.removeProperty('transition-duration');
        // target.style.removeProperty('transition-property');
        target.style.removeProperty('transition');
        clearTimeout(timer);
        next(target, duration);
    }, duration);
};
let slideDown = (target, duration = 500) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none')
        display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    // target.offsetHeight;
    // target.offsetHeight;
    // target.style.boxSizing = 'border-box';
    // target.style.transitionProperty = "height, margin, padding";
    // target.style.transitionDuration = duration + 'ms';
    // target.style.transition = `height ${duration}ms, margin ${duration}ms, padding ${duration}ms`;
    let addHeightTimer = setTimeout(() => {
        // target.style.paddingTop = 0;
        // target.style.paddingBottom = 0;
        // target.style.marginTop = 0;
        // target.style.marginBottom = 0;
        // target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transition = `height ${duration}ms, margin ${duration}ms, padding ${duration}ms`;
        target.style.height = convertToRem(height);
        clearTimeout(addHeightTimer);
    }, 0);
    // target.style.transition = `height ${duration}ms, margin ${duration}ms, padding ${duration}ms`;
    // target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    let timer = window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        // target.style.removeProperty('transition-duration');
        // target.style.removeProperty('transition-property');
        target.style.removeProperty('transition');
        clearTimeout(timer);
        next(target, duration);
    }, duration);
};
let timers = [];
let isStart = false;
let add = (timer, target, duration, fromAll) => {
    timers.push(timer);
    run(target, duration, fromAll);
};
let run = (target, duration, fromAll) => {
    if (fromAll) {
        let firstTimer = timers.shift();
        if (firstTimer) {
            isStart = true;
            firstTimer(target, duration);
        }
        return;
    }
    if (!isStart) {
        let firstTimer = timers.shift();
        if (firstTimer) {
            isStart = true;
            firstTimer(target, duration);
        }
    }
};
let next = (target, duration) => {
    isStart = false;
    run(target, duration);
};
let slideTrigger = (isSlideUp, target, duration = 500, fromAll) => {
    if (isSlideUp) {
        add(slideUp, target, duration, fromAll);
    }
    else {
        add(slideDown, target, duration, fromAll);
    }
};

class ThemeService {
    constructor() {
        this.theme = new BehaviorSubject('');
        this.themePrimaryColor = new BehaviorSubject('');
        this.themeToken = new BehaviorSubject('');
        this.componentBackground = new BehaviorSubject('');
        this.preferenceBackground = new BehaviorSubject('');
        this.themeChange = new BehaviorSubject('');
        this.currentUrlSubject = new BehaviorSubject('');
        this.currentUrl$ = this.currentUrlSubject.asObservable();
        this.isTooltipHoveredSubject = new BehaviorSubject('');
        this.primaryColorSubject = new BehaviorSubject('');
        this.primaryColor$ = this.primaryColorSubject.asObservable();
        this.currentParamsSubject = new BehaviorSubject({});
        this.currentParams$ = this.currentParamsSubject.asObservable();
        this.appearanceSubject = new BehaviorSubject('');
        this.appearance$ = this.appearanceSubject.asObservable();
        this.enableThemeChange = true;
        this.latestVisitedUrlSubject = new BehaviorSubject({});
        this.$latestVisitedUrl = this.latestVisitedUrlSubject.asObservable();
        this.projectVersion = new BehaviorSubject('');
        this.showLanguage = new BehaviorSubject(true);
        this.initialVersion = new BehaviorSubject('angular');
    }
    getVersionParam() {
        return { version: this.projectVersion.value || this.initialVersion.value };
    }
    changeInitialVersion(version) {
        this.initialVersion.next(version);
    }
    changeVersion(version) {
        this.projectVersion.next(version);
    }
    addLatestVisitedUrl(urlInfo) {
        this.latestVisitedUrlSubject.next(urlInfo);
    }
    changePrimaryColor(color) {
        this.primaryColorSubject.next(color);
    }
    changeTooltipHover(hoverStatus) {
        this.isTooltipHoveredSubject.next(hoverStatus);
    }
    changeTheme(theme) {
        this.theme.next(theme);
    }
    getThemePrimaryColor() {
        return this.themePrimaryColor;
    }
    changeCurrentParams(paramsObj) {
        this.currentParamsSubject.next(paramsObj);
    }
    getThemeToken() {
        return this.themeToken;
    }
    hexToRGB(hex) {
        if (!/#[0-9a-f]{6}/i.test(hex)) {
            throw new TypeError(`hex has wrong length: ${hex}`);
        }
        return `${parseInt(hex.substring(1, 3), 16)}, ${parseInt(hex.substring(3, 5), 16)}, ${parseInt(hex.substring(5, 7), 16)}`;
    }
    selectTheme(theme, event) {
        if (event && (Array.from(event.target.classList).indexOf('ap-theme-icon') > -1 || event.target.nodeName === 'INPUT')) {
            return;
        }
        this.themePrimaryColor.next(theme);
        this.themeToken.next({ name: 'color-background-primary', value: theme.color });
        document.body.classList.add('interaction');
        this.themeChange.next(theme);
        localStorage.setItem('apTheme', theme.color);
        localStorage.setItem('apThemeName', theme.name);
        setTimeout(() => {
            document.body.classList.remove('interaction');
        }, 300);
        return theme.name;
    }
    changeBackground(background) {
        this.componentBackground.next(background);
    }
    changePreferenceBackground(background) {
        localStorage.setItem("preferenceBackground", background);
        this.preferenceBackground.next(background);
    }
    changeAppearance(appearance) {
        this.appearanceSubject.next(appearance);
    }
    changeurl(url) {
        this.currentUrlSubject.next(url);
    }
    getUrlParams(url) {
        let paramArr = [];
        let paramObj = {};
        let pathIndex = url?.indexOf('?');
        let restPath = url?.substring(pathIndex + 1);
        if (restPath.indexOf('&') > -1)
            paramArr = restPath.split('&');
        else if (restPath.length > 0 && restPath.indexOf('=') > -1) { // only have one param
            let tempArr = restPath.split('=');
            paramObj[tempArr[0]] = tempArr[1];
        }
        paramArr.forEach((item) => {
            let tempArr = item.split('=');
            paramObj[tempArr[0]] = tempArr[1];
        });
        return paramObj;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ThemeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ThemeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ThemeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class dialogStyles {
    constructor() {
        this.alignDirection = 'top-left';
        this.top = 0; // Offset on the y-axis. Could be positive or negative number.
        this.left = 0; // Offset on the x-axis. Could be positive or negative number.
        this.spacingY = 0; // Vertical distance between dialog and parent element. Always a positive number.
        this.spacingX = 0; // Horizontal distance between dialog and parent element. Always a positive number.
    }
}
class DialogService {
    // private _destroy$ = new Subject();
    // public windowEventObservable$: Observable<Event>;
    constructor(rendererFactory) {
        this.className = '';
        this.dialogs = [];
        this.renderer = rendererFactory.createRenderer(null, null);
        // this.createWindowObservable();
    }
    // ngOnDestroy() {
    //   this._destroy$.next();
    //   this._destroy$.complete();
    // }
    // private createWindowObservable() {
    //   let removeScrollEventListener: () => void;
    //   let removeResizeEventListener: () => void;
    //   const createWindowEventListener = (handler: (e: Event) => boolean | void) => {
    //     removeScrollEventListener = this.renderer.listen("window", "scroll", handler);
    //     removeResizeEventListener = this.renderer.listen("window", "resize", handler);
    //   };
    //   this.windowEventObservable$ = fromEventPattern<Event>(createWindowEventListener, () => {
    //     removeScrollEventListener();
    //     removeResizeEventListener();
    //   }).pipe(takeUntil(this._destroy$));
    // }
    // Styles for dialog with attached DOM. Positon is relative to the window.
    setDialogStyles(hostEle, dialog, dialogStyles) {
        const hostEleRect = hostEle.getBoundingClientRect();
        let dialogEle = dialog;
        dialogEle.style.right = 'unset';
        dialogEle.style.bottom = 'unset';
        switch (dialogStyles.alignDirection) {
            case 'top':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.top) - Number(dialogEle.offsetHeight) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.left) + (hostEleRect.width - dialogEle.offsetWidth) / 2 + Number(dialogStyles.left));
                break;
            case 'top-left':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.top) - Number(dialogEle.offsetHeight) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.left) + Number(dialogStyles.left));
                break;
            case 'top-right':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.top) - Number(dialogEle.offsetHeight) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.right) - Number(dialogEle.offsetWidth) + Number(dialogStyles.left));
                break;
            case 'bottom':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.bottom) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.left) + (hostEleRect.width - dialogEle.offsetWidth) / 2 + Number(dialogStyles.left));
                break;
            case 'bottom-left':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.bottom) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.left) + Number(dialogStyles.left));
                break;
            case 'bottom-right':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.bottom) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.right) - Number(dialogEle.offsetWidth) + Number(dialogStyles.left));
                break;
            case 'left':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.top) + (hostEleRect.height - dialogEle.offsetHeight) / 2 + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.left) - Number(dialogEle.offsetWidth) + Number(dialogStyles.left));
                break;
            case 'left-top':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.top) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.left) - Number(dialogEle.offsetWidth) + Number(dialogStyles.left));
                break;
            case 'left-bottom':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.bottom) - Number(dialogEle.offsetHeight) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.left) - Number(dialogEle.offsetWidth) + Number(dialogStyles.left));
                break;
            case 'right':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.top) + (hostEleRect.height - dialogEle.offsetHeight) / 2 + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.right) + Number(dialogStyles.left));
                break;
            case 'right-top':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.top) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.right) + Number(dialogStyles.left));
                break;
            case 'right-bottom':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.bottom) - Number(dialogEle.offsetHeight) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.right) + Number(dialogStyles.left));
                break;
            default:
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.top) - Number(dialogEle.offsetHeight) + Number(dialogStyles.top));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.left) + (hostEleRect.width - Number(dialogEle.offsetWidth)) / 2 + Number(dialogStyles.left));
        }
    }
    // Styles for dialog without attached DOM. Positon is relative to the parent element.
    setFixedDialogStyle(hostEle, dialog, dialogStyles) {
        const hostEleRect = hostEle.getBoundingClientRect();
        let dialogEle = dialog;
        switch (dialogStyles.alignDirection) {
            case 'top':
                dialogEle.style.top = 'unset';
                dialogEle.style.right = 'unset';
                dialogEle.style.bottom = convertToRelativeRem(Number(hostEleRect.height) + Number(dialogStyles.spacingY));
                dialogEle.style.left = convertToRelativeRem((-1 * (Number(dialogEle.offsetWidth) - Number(hostEleRect.width)) / 2) + Number(dialogStyles.spacingX));
                break;
            case 'top-left':
                dialogEle.style.top = 'unset';
                dialogEle.style.right = 'unset';
                dialogEle.style.bottom = convertToRelativeRem(Number(hostEleRect.height) + Number(dialogStyles.spacingY));
                dialogEle.style.left = convertToRelativeRem(Number(dialogStyles.spacingX));
                break;
            case 'top-right':
                dialogEle.style.top = 'unset';
                dialogEle.style.right = convertToRelativeRem(Number(dialogStyles.spacingX));
                dialogEle.style.bottom = convertToRelativeRem(Number(hostEleRect.height) + Number(dialogStyles.spacingY));
                dialogEle.style.left = 'unset';
                break;
            case 'bottom':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.height) + Number(dialogStyles.spacingY));
                dialogEle.style.right = 'unset';
                dialogEle.style.bottom = 'unset';
                dialogEle.style.left = convertToRelativeRem((-1 * (Number(dialogEle.offsetWidth) - Number(hostEleRect.width)) / 2) + Number(dialogStyles.spacingX));
                break;
            case 'bottom-left':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.height) + Number(dialogStyles.spacingY));
                dialogEle.style.right = 'unset';
                dialogEle.style.bottom = 'unset';
                dialogEle.style.left = convertToRelativeRem(Number(dialogStyles.spacingX));
                break;
            case 'bottom-right':
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.height) + Number(dialogStyles.spacingY));
                dialogEle.style.right = convertToRelativeRem(Number(dialogStyles.spacingX));
                dialogEle.style.bottom = 'unset';
                dialogEle.style.left = 'unset';
                break;
            case 'left':
                dialogEle.style.top = convertToRelativeRem((-1 * (Number(dialogEle.offsetHeight) - Number(hostEleRect.height)) / 2) + Number(dialogStyles.spacingY));
                dialogEle.style.right = convertToRelativeRem(Number(hostEleRect.width) + Number(dialogStyles.spacingX));
                dialogEle.style.bottom = 'unset';
                dialogEle.style.left = 'unset';
                break;
            case 'left-top':
                dialogEle.style.top = convertToRelativeRem(Number(dialogStyles.spacingY));
                dialogEle.style.right = convertToRelativeRem(Number(hostEleRect.width) + Number(dialogStyles.spacingX));
                dialogEle.style.bottom = 'unset';
                dialogEle.style.left = 'unset';
                break;
            case 'left-bottom':
                dialogEle.style.top = 'unset';
                dialogEle.style.right = convertToRelativeRem(Number(hostEleRect.width) + Number(dialogStyles.spacingX));
                dialogEle.style.bottom = convertToRelativeRem(Number(dialogStyles.spacingY));
                dialogEle.style.left = 'unset';
                break;
            case 'right':
                dialogEle.style.top = convertToRelativeRem((-1 * (Number(dialogEle.offsetHeight) - Number(hostEleRect.height)) / 2) + Number(dialogStyles.spacingY));
                dialogEle.style.right = 'unset';
                dialogEle.style.bottom = 'unset';
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.width) + Number(dialogStyles.spacingX));
                break;
            case 'right-top':
                dialogEle.style.top = convertToRelativeRem(Number(dialogStyles.spacingY));
                dialogEle.style.right = 'unset';
                dialogEle.style.bottom = 'unset';
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.width) + Number(dialogStyles.spacingX));
                break;
            case 'right-bottom':
                dialogEle.style.top = 'unset';
                dialogEle.style.right = 'unset';
                dialogEle.style.bottom = convertToRelativeRem(Number(dialogStyles.spacingY));
                dialogEle.style.left = convertToRelativeRem(Number(hostEleRect.width) + Number(dialogStyles.spacingX));
                break;
            default:
                dialogEle.style.top = convertToRelativeRem(Number(hostEleRect.height) + Number(dialogStyles.spacingY));
                dialogEle.style.right = convertToRelativeRem(Number(dialogStyles.spacingX));
                dialogEle.style.bottom = 'unset';
                dialogEle.style.left = 'unset';
        }
    }
    setDialogTransformOrigin(dialog, alignDirection) {
        let dialogEle = dialog;
        switch (alignDirection) {
            case 'top':
                dialogEle.style['transform-origin'] = 'bottom';
                break;
            case 'bottom':
                dialogEle.style['transform-origin'] = 'top';
                break;
            case 'left':
                dialogEle.style['transform-origin'] = 'right';
                break;
            case 'right':
                dialogEle.style['transform-origin'] = 'left';
                break;
            case 'top-left':
            case 'right-bottom':
                dialogEle.style['transform-origin'] = 'bottom left';
                break;
            case 'top-right':
            case 'left-bottom':
                dialogEle.style['transform-origin'] = 'bottom right';
                break;
            case 'bottom-left':
            case 'right-top':
                dialogEle.style['transform-origin'] = 'top left';
                break;
            case 'bottom-right':
            case 'left-top':
                dialogEle.style['transform-origin'] = 'top right';
                break;
            default:
                dialogEle.style['transform-origin'] = 'top right';
        }
    }
    setDialogPosition(dialogEle, attachedDOM, dialogContainerId) {
        let id = dialogContainerId || String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now();
        const dialogContainer = this.renderer.createElement('div');
        this.renderer.setAttribute(dialogContainer, 'id', 'dialog-container-' + id);
        this.renderer.addClass(dialogContainer, 'ap-dialog-container');
        if (this.className && this.className.length > 0) {
            this.renderer.addClass(dialogContainer, this.className);
        }
        ;
        this.renderer.appendChild(dialogContainer, dialogEle);
        this.renderer.appendChild(document.querySelector(attachedDOM), dialogContainer);
        this.dialogs.push({ id, dialogEle, attachedDOM });
        return { dialogContainerId: 'dialog-container-' + id };
    }
    destroyDialogContainer(attachedDOM, dialogContainerId) {
        this.dialogs = this.dialogs.filter((dialog) => dialog.id !== dialogContainerId.substring(17));
        this.renderer.removeChild(document.querySelector(attachedDOM), document.getElementById(dialogContainerId));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: DialogService, deps: [{ token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: DialogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: DialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i0.RendererFactory2 }] });

class ThemeDirective {
    constructor(elementRef, themeService) {
        this.elementRef = elementRef;
        this.themeService = themeService;
        this.unsubscribe = new Subject();
    }
    ngOnDestroy() {
        this.themeSubscription?.unsubscribe();
    }
    ngAfterViewInit() {
        this.themeSubscription = this.themeService.themeChange.pipe(takeUntil(this.unsubscribe))
            .subscribe((theme) => this.updateTheme(theme));
    }
    updateTheme(theme) {
        if (!theme)
            return;
        if (theme.name !== 'Customization') {
            const elementTagName = this.elementRef.nativeElement.tagName?.toLowerCase();
            switch (elementTagName) {
                case 'ap-modal':
                    document.body.querySelectorAll('.ap-modal-wrapper').forEach(item => {
                        if (item.parentNode.getAttribute('ng-reflect-id') === this.elementRef.nativeElement.getAttribute('appmodalid')) {
                            item.setAttribute('data-theme', theme.name?.toLowerCase().replace(/\s/g, '-'));
                        }
                    });
                    break;
                default:
                    if (typeof this.elementRef.nativeElement.setAttribute === 'function')
                        this.elementRef.nativeElement.setAttribute('data-theme', theme.name?.toLowerCase().replace(/\s/g, '-'));
                    else
                        this.addWrapperTheme(this.elementRef.nativeElement, theme);
                    break;
            }
            document.body.style.removeProperty('--colors-background-primary');
            document.body.style.removeProperty('--colors-background-primary-rgb');
        }
        else {
            if (typeof this.elementRef.nativeElement.setAttribute === 'function') {
                this.elementRef.nativeElement.removeAttribute('data-theme');
                this.elementRef.nativeElement.style.cssText = `--colors-background-primary: ${theme.color};
                                      --colors-background-primary-rgb: ${this.themeService.hexToRGB(theme.color)}`;
            }
            else {
                document.body.removeAttribute('data-theme');
                document.body.style.setProperty('--colors-background-primary', theme.color);
                document.body.style.setProperty('--colors-background-primary-rgb', this.themeService.hexToRGB(theme.color));
            }
        }
    }
    addWrapperTheme(node, theme) {
        const par = this.findParentBySelector(node);
        par?.setAttribute('data-theme', theme.name?.toLowerCase().replace(/\s/g, '-'));
    }
    findParentBySelector(elm) {
        var cur = elm.parentNode;
        while (cur && (!(cur instanceof Element) || cur.tagName.toLowerCase() === 'app-root')) { //keep going up until you find a match
            cur = cur.parentNode; //go up
        }
        return cur; //will return null if not found
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ThemeDirective, deps: [{ token: i0.ElementRef }, { token: ThemeService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.11", type: ThemeDirective, selector: "[app-theme]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ThemeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[app-theme]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: ThemeService }] });

class FocusIndicatorService {
    constructor() {
        this.keydownObservable$ = fromEvent(window, "keydown");
        this.clickObservable$ = fromEvent(window, "click");
        this.keydownSubscription$ = this.keydownObservable$.subscribe((event) => {
            const keycode = window.event ? event.keyCode : event.which;
            if (keycode === 9) {
                document.body?.setAttribute("data-keyboard-focus", "true");
            }
        });
        this.clickSubscription$ = this.clickObservable$.subscribe((event) => {
            const detail = event.detail;
            if (detail > 0 && document.body?.getAttribute("data-keyboard-focus")) {
                document.body?.removeAttribute("data-keyboard-focus");
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FocusIndicatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FocusIndicatorService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FocusIndicatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class SharedModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: SharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: SharedModule, declarations: [ThemeDirective], exports: [ThemeDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: SharedModule, providers: [
            ThemeService,
            DialogService,
            FocusIndicatorService,
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: SharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ThemeDirective],
                    exports: [ThemeDirective],
                    providers: [
                        ThemeService,
                        DialogService,
                        FocusIndicatorService,
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DialogService, FocusIndicatorService, SharedModule, ThemeDirective, ThemeService, dialogStyles, slideDown, slideToggle, slideTrigger, slideUp };
